import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children, apiBaseUrl }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRoles, setUserRoles] = useState([]);

  const refreshAuth = () => {
    fetch(`${apiBaseUrl}/user/roles`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        setIsAuthenticated(data.roles.length > 0);
        setUserRoles(data.roles);
      })
      .catch(err => {
        console.error('Error fetching auth status:', err);
        setIsAuthenticated(false);
        setUserRoles([]);
      });
  };

  useEffect(() => {
    refreshAuth(); // Initial check
  }, [apiBaseUrl]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, userRoles, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);